var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"app-loader bg-primary bg-gradient"},[_c('div',[_c('span',{staticClass:"loader"}),(_vm.title)?_c('p',[_vm._v(_vm._s(_vm.title))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }